import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import { getConfig as getConfigService } from "../../services/config.service.ts";
import {
  OfferConfig,
  parseOfferConfig,
} from "../../features/offer/types/offer-config.ts";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export const getConfig = createAsyncThunk<OfferConfig, void, ThunkApi>(
  "getConfig",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await getConfigService();
      return parseOfferConfig(data);
    } catch (err: any) {
      pushErrorMonitor(err);
      const error: LayoutError = {
        title: "Recupero configurazione",
        description:
          "Non siamo riusciti a recuperare la configurazione.\n Puoi riprovare o contattare il supporto",
        error: err.message,
      };
      return rejectWithValue(error);
    }
  },
);
